<template>
  <nav-menu name="Start" :icon="mdiPlay" v-bind="$attrs" v-on="$listeners">
    <start-btn-list class="transparent" />
  </nav-menu>
</template>


<script>
import NavMenu from '@/components/NavMenu.vue';
import StartBtnList from '@/components/StartBtnList.vue';
import { mdiPlay } from '@mdi/js';

export default {
  name: 'nav-menu-start',
  components: { NavMenu, StartBtnList },
  created() {
    Object.assign(this, { mdiPlay });
  }
}
</script>
